import { ILocaleSiteLinks } from '@Hotels-at-Home/hah-fe-core/dist/types/header';
import { IImage } from '@Hotels-at-Home/hah-fe-core/dist/types/image';
import { catalogId } from './siteConfig';

export const siteLinks: ILocaleSiteLinks = {
  en: [
    {
      id: 1,
      url: `https://europe.shopmarriott.com/en?___store=mareu_en&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=MAREU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Shop Marriott',
    },
    {
      id: 2,
      url: `https://europe.sheratonstore.com/en?___store=sheu_en&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=SHEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Sheraton Store',
    },
    {
      id: 3,
      url: `https://europe.collectrenaissance.com/en?___store=rhreu_en&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=RHREU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Collect Renaissance',
    },
    {
      id: 4,
      url: `https://europe.shoplemeridien.com/en?___store=lemeu_en&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=LEMEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Shop Le Méridien',
    },
  ],
  fr: [
    {
      id: 1,
      url: `https://europe.shopmarriott.com/fr?___store=mareu_fr&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=MAREU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Shop Marriott',
    },
    {
      id: 2,
      url: `https://europe.sheratonstore.com/fr?___store=sheu_fr&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=SHEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Sheraton Store',
    },
    {
      id: 3,
      url: `https://europe.collectrenaissance.com/fr?___store=rhreu_fr&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=RHREU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Collect Renaissance',
    },
    {
      id: 4,
      url: `https://europe.shoplemeridien.com/fr?___store=lemeu_fr&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=LEMEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Shop Le Méridien',
    },
  ],
  de: [
    {
      id: 1,
      url: `https://europe.shopmarriott.com/de?___store=mareu_de&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=MAREU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Shop Marriott',
    },
    {
      id: 2,
      url: `https://europe.sheratonstore.com/de?___store=sheu_de&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=SHEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Sheraton Store',
    },
    {
      id: 3,
      url: `https://europe.collectrenaissance.com/de?___store=rhreu_de&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=RHREU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Collect Renaissance',
    },
    {
      id: 4,
      url: `https://europe.shoplemeridien.com/de?___store=lemeu_de&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=LEMEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Shop Le Méridien',
    },
  ],
  es: [
    {
      id: 1,
      url: `https://europe.shopmarriott.com/es?___store=mareu_es&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=MAREU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Shop Marriott',
    },
    {
      id: 2,
      url: `https://europe.sheratonstore.com/es?___store=sheu_es&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=SHEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Sheraton Store',
    },
    {
      id: 3,
      url: `https://europe.collectrenaissance.com/es?___store=rhreu_es&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=RHREU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Collect Renaissance',
    },
    {
      id: 4,
      url: `https://europe.shoplemeridien.com/es?___store=lemeu_es&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=LEMEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Shop Le Méridien',
    },
  ],
};

export const bonvoyLogo: IImage = {
  src: '/images/misc/bonvoy-logo.svg',
  alt: 'Shop logo',
  height: '47.25',
  width: '100',
};
